import { useState, useRef, useEffect } from 'react'
import { Search, Bell } from 'lucide-react'
import { useAuth } from '../auth/AuthContext'
import styles from './Topbar.module.css'


const ROLE_NAMES: Record<string, string> = {
  front_desk: 'Front-Desk Admin', quality_assurance: 'Head of Compliance', ceo_executive_assistant: 'CEO Executive Assistant',
}

export default function Topbar() {
  const { user, logout } = useAuth()
  const [menuOpen, setMenuOpen] = useState(false)
  const menuRef = useRef<HTMLDivElement>(null)
  const initials = user ? user.name.slice(0, 2).toUpperCase() : ''

  useEffect(() => {
    function onClickOutside(e: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) setMenuOpen(false)
    }
    document.addEventListener('mousedown', onClickOutside)
    return () => document.removeEventListener('mousedown', onClickOutside)
  }, [])

  return (
    <div className={styles.topbar}>
      <span className={styles.title}>Little Scholars — Ops</span>
      <div className={styles.spacer} />
      <Search size={18} strokeWidth={1.75} className={styles.icon} aria-hidden="true" />
      <Bell size={18} strokeWidth={1.75} className={styles.icon} aria-hidden="true" />
      {user && (
        <div className={styles.accountMenu} ref={menuRef}>
          <button className={styles.avatar} onClick={() => setMenuOpen((o) => !o)}>
            {initials}
          </button>
          {menuOpen && (
            <div className={styles.dropdown}>
              <div className={styles.dropdownName}>{user.name}</div>
              <div className={styles.dropdownRole}>{user.roleLabel ?? ROLE_NAMES[user.role] ?? user.role.replace(/_/g, ' ')}</div>
              <button className={styles.signOutBtn} onClick={logout}>
                Sign out
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  )
}
